import React from "react";
import { GppBad, TaxiAlert } from "@material-ui/icons";
import { Badge, styled } from "@mui/material";
import { formatTimeWithIntegers, iconMap } from "../../../../contexts/BookingUtilities";
import axios from "../../../../utils/axios";
import { cLog, cWarn } from "../../CustomLogger";
import ProgressIcon from "../../TaxiBookingCommon/ProgressIcon";
import ProgressIconSmall from "../../TaxiBookingCommon/ProgressIconSmall";

export const TaxiPlaceholders = async (pointContext) => {
    
     try{
    
        const {
            state:{
                point:{
                    transportData:{
                        selfBook=1,
                        travelTime,
                        hoursMin=[]
                    }
                },
                searchRes,
                index,
                booking,
                booking:{
                    parentApprovedDate:bookingApproved
                },
            },
            brandContext:{
                brand:{
                    mode:scope
                },
                textContent:{
                    fulfilledTaxtTitle=''
                }
            },
        } = pointContext;

        const timeLabel = formatTimeWithIntegers(travelTime,hoursMin); 

        
        
        const {
            bookingLegs=[],
            id:bookingId,
        } = booking;
        
        
        let taxiBookingId = '';
        let taxiBooking = null;
        let transportIcon = null;
        let statusName = 'Pending';
        let transportTitle = '';

        if(selfBook !== '1'){
            if(bookingApproved){
                if(bookingLegs.length > 0){
                    const leg = bookingLegs[index];

                    try{
                        const {legToTaxi} = leg;
                        if(legToTaxi){
                            const {taxiBooking:taxiBookingDb} = legToTaxi;
                            if(taxiBookingDb){
                                ({    
                                    id:taxiBookingId,
                                } = taxiBookingDb);
                                taxiBooking = taxiBookingDb;
                                const {taxiBookingJobs} = taxiBooking;
                                if(taxiBookingJobs.length > 0){
                                    for(let i=0; i<taxiBookingJobs.length; i+=1){
                                        if(taxiBookingJobs[i].isActive){
                                            const taxiBookingJob = taxiBookingJobs[i];
                                            ({
                                                status:{
                                                    name:statusName=''
                                                },
                                            } = taxiBookingJob);
                                            break;
                                        }
                                    }
                                }
                            }

                        }
                    }
                    catch(e){
                        cWarn(e); 
                    }

                    transportTitle = `${fulfilledTaxtTitle}: ${statusName}`;
                }
                if(!searchRes){
                    let apiPath = `${process.env.REACT_APP_API_URL}/taxidetailsbybooking/${scope}/${bookingId}/${index}`;
                    if(taxiBookingId ){
                        apiPath = `${process.env.REACT_APP_API_URL}/taxidetails/${scope}/${taxiBookingId}`;
                    }
                    let taxiData = {};
                    let fullData = {};
                    await axios
                        .get(apiPath, {
                            timeout: 300000,
                            withCredentials: true,
                        })
                        .then((res) => {
                            ({ 
                                data: taxiData,
                                data:{
                                    fullData
                                }
                            } = res);
                            if(Object.keys(taxiData).length > 0){
                                transportIcon = <ProgressIcon taxiBooking={fullData}/>;
                            }
                            else{
                                return {
                                    error:true,
                                    transportTimeLabel:timeLabel
                                };    
                            }
                        })
                        .catch((err) => {
                            cWarn(err);            
                            return {
                                error:true,
                                transportTimeLabel:timeLabel
                            };        
                        });
                    
                    return {
                        transportTitle,
                        taxiData,
                        transportIcon,
                        transportTimeLabel:timeLabel,
                        iconPrepped:true
                    };   
                }
                if(taxiBooking){
                    transportIcon = <ProgressIconSmall taxiBooking={taxiBooking} />;
                }
            }
            else{
                if(searchRes){
                    transportIcon = <ProgressIconSmall taxiBooking={{
                        taxiBookingJobs:[
                            {
                                isActive:true,
                                status:{
                                    id:9
                                }
                            }
                        ]
                    }} />;
                }
                else{
                    transportIcon = <ProgressIcon taxiBooking={{
                        taxiBookingJobs:[
                            {
                                isActive:true,
                                status:{
                                    id:9
                                }
                            }
                        ]
                    }} />;
                }
                transportTitle = 'Taxi: Awaiting Approval';
                statusName = 'Unapproved';
            }
            return {
                transportTitle,
                transportIcon,
                transportTimeLabel:timeLabel,
                iconPrepped:true
            };
            

        }
        
        const StyledBadge = styled(Badge)(({ theme }) => ({
            '& .MuiBadge-badge': {
                right: 6,
                top: 6,
                border: `1px solid ${theme.palette.background.paper}`,
                padding: '0 0px',
                width:'12px',
                minWidth:'12px',
                height:'12px',
                backgroundColor:'#FF0000'
            },
            }));

            

        return {
            transportTimeLabel:timeLabel,
            // transportIcon:<TaxiAlert/>
        };
    }
    catch(e){
        cWarn(e);
        return {};
    }

    
    
}


